export default __webpack_public_path__ + "static/media/2_0100.bfb7186a.webp";